
import { Component, Prop, Vue } from "vue-property-decorator";
import { TAnswerBlock } from "@/models/questionnaire";
import { SMCases, SMQuestionnaire, SMToaster, SMUser } from "@/store";
import {
  SPONSOR_LICENCE_SERVICE_TYPE,
  STEPS_TO_TRIGGER_SERVICE_UPDATE,
} from "@/constants/services";
import copy from "copy-to-clipboard";

const CLASS_NAMESPACE = "profile-question";

const EVENT_TYPE = "add";

const ICONS = { add: "add" };

@Component
export default class ProfileRow extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly answerBlocks!: TAnswerBlock[];
  @Prop([String, Boolean]) readonly label: string | boolean | undefined;
  @Prop({ type: Boolean, default: false }) readonly showLabel!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isEditable!: boolean;
  @Prop({ type: Number }) readonly stepID: number | undefined;
  @Prop({ type: Boolean, default: false }) readonly isLooped!: boolean;

  icons = ICONS;

  eventType = EVENT_TYPE;

  // TASK: Need to refactoring in future, because indexes has different types;
  getAliasResult(aliasResult: string): string {
    switch (aliasResult) {
      case "true":
        return "Yes";
      case "false":
        return "No";
      case "<nil>":
        return "-";
      case " ":
        return "-";
      case "":
        return "-";
      default:
        return aliasResult
          .toString()
          .replaceAll(",,", ", ")
          .trim();
    }
  }

  get caseId() {
    return Number(this.$route.params.id ?? 0);
  }

  popup = false;

  get loopedAnswerBlocks() {
    const indexes = [...new Set(this.answerBlocks.map((item) => item.loop_index))];

    return indexes.map((index) =>
      this.answerBlocks.filter((answerBlock) => answerBlock.loop_index === index)
    );
  }

  isLastAnswerBlock(index: number) {
    return index === this.loopedAnswerBlocks.length - 1;
  }

  showDivider(index: number) {
    return this.isLooped && !this.isLastAnswerBlock(index);
  }

  async editStep(type: string, label?: string) {
    const { caseId, stepID: stepId } = this;

    if (!caseId || !stepId) return;

    if (SMCases.caseType === SPONSOR_LICENCE_SERVICE_TYPE) {
      await SMQuestionnaire.setAnswerQuery({ case_id: caseId });

      const serviceNeedsUpdate = STEPS_TO_TRIGGER_SERVICE_UPDATE.includes(label);

      if (serviceNeedsUpdate) SMCases.setServiceNeedsUpdate(true);
    }

    this.$emit("edit", {
      caseId,
      stepId,
      type,
    });
  }

  getLabel(answer: TAnswerBlock) {
    return answer?.show_label ? answer?.label : "";
  }

  get classes() {
    const { isEditable } = this;

    return {
      [`${CLASS_NAMESPACE}_editable`]: isEditable,
    };
  }

  showProfileRow(condition: string, answerBlocks: TAnswerBlock[]) {
    if (!condition.includes("==") || condition.includes("{")) return true;

    const conditions = condition.includes("||") ? condition.split("||") : [condition];

    return conditions
      .map((condition) => {
        const [conditionAnswerBlockAlias, conditionAnswer] = condition.split("==");

        return !!answerBlocks.find(
          (answerBlock) =>
            answerBlock.answer_block_alias === conditionAnswerBlockAlias.trim() &&
            answerBlock.alias_result === conditionAnswer.trim()
        );
      })
      .includes(true);
  }

  onRightClick(result: string) {
    if (!result) return;

    if (!SMUser.isExpert) return;

    const text = this.getAliasResult(result);

    if (!text) return;

    copy(text);

    SMToaster.emitSuccess({
      title: this.$root.$tc("notification.copied").toString(),
      message: text,
    });
  }
}
